import { put, take, takeEvery } from "redux-saga/effects";
import { createAction } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { closePostForm } from "features/post";
import { savePostForm } from "../../actions/postForm";
import { SAVE_POST_FORM_ROUTINE } from "../../constants/ActionTypes";
import { registerModal } from "libs/modals";
import { AddInstagramSuggestion } from "./components/add-instagram-account-suggestion";
import type { PlannerPostData } from "features/post/components/CreatePostModal";
import type { SaveFormResult } from "components/Posts/PostForm/types";

export const addInstagramSuggestionModal = registerModal(
  "PLANNER_PAGE_ADD_INSTAGRAM_SUGGESTION",
  AddInstagramSuggestion
);

interface PlannerPageScheduleClusterPostPayload {
  initialPost: PlannerPostData;
  scheduledPost: PlannerPostData;
}

export const plannerPageScheduleClusterPost =
  createAction<PlannerPageScheduleClusterPostPayload>(
    "plannerPageScheduleClusterPost"
  );

function* scheduleClusterPostSaga({
  payload: { initialPost, scheduledPost },
}: PayloadAction<PlannerPageScheduleClusterPostPayload>) {
  yield put(savePostForm(scheduledPost));
  yield take(SAVE_POST_FORM_ROUTINE.SUCCESS);
  yield put(closePostForm(toSaveFormResult(initialPost)));
}

function toSaveFormResult(postData: PlannerPostData): SaveFormResult {
  return {
    ...postData,
    platformFields: {},
    platforms: [],
  };
}

export function* planerPageSaga() {
  yield takeEvery(plannerPageScheduleClusterPost.type, scheduleClusterPostSaga);
}
